import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import * as d3 from "d3";
import { formatHours } from "@/utils/duration";
export function ClientHoursBars({ data, metric, onPick, }) {
    const ref = useRef(null);
    useEffect(() => {
        if (!ref.current)
            return;
        const svg = d3.select(ref.current);
        svg.selectAll("*").remove();
        const width = 720;
        const rowH = 34;
        const height = Math.max(80, data.length * rowH + 24);
        const margin = { top: 8, right: 80, bottom: 8, left: 180 };
        svg.attr("viewBox", `0 0 ${width} ${height}`);
        const sorted = [...data].sort((a, b) => b[metric] - a[metric]);
        const xMax = d3.max(sorted, (d) => d[metric]) ?? 0;
        const x = d3
            .scaleLinear()
            .domain([0, xMax || 1])
            .range([margin.left, width - margin.right]);
        const y = d3
            .scaleBand()
            .domain(sorted.map((d) => d.client))
            .range([margin.top, height - margin.bottom])
            .padding(0.28);
        const defs = svg.append("defs");
        const grad = defs
            .append("linearGradient")
            .attr("id", "clientBar")
            .attr("x1", "0").attr("y1", "0").attr("x2", "1").attr("y2", "0");
        grad.append("stop").attr("offset", "0%").attr("stop-color", "#2563EB");
        grad.append("stop").attr("offset", "100%").attr("stop-color", "#14B8A6");
        const row = svg
            .selectAll("g.row")
            .data(sorted)
            .enter()
            .append("g")
            .attr("class", "row")
            .style("cursor", onPick ? "pointer" : "default")
            .on("click", (_, d) => onPick && onPick(d.client));
        row.append("text")
            .attr("x", margin.left - 12)
            .attr("y", (d) => (y(d.client) ?? 0) + y.bandwidth() / 2 + 4)
            .attr("text-anchor", "end")
            .attr("fill", "#334155")
            .style("font-size", "12px")
            .style("font-weight", "500")
            .text((d) => d.client);
        row.append("rect")
            .attr("x", margin.left)
            .attr("y", (d) => y(d.client) ?? 0)
            .attr("width", 0)
            .attr("height", y.bandwidth())
            .attr("rx", 6)
            .attr("fill", "url(#clientBar)")
            .transition()
            .duration(450)
            .attr("width", (d) => Math.max(2, x(d[metric]) - margin.left));
        row.append("text")
            .attr("x", (d) => x(d[metric]) + 8)
            .attr("y", (d) => (y(d.client) ?? 0) + y.bandwidth() / 2 + 4)
            .attr("fill", "#0F172A")
            .style("font-size", "12px")
            .style("font-weight", "600")
            .text((d) => (metric === "hours" ? `${formatHours(d.hours)}h` : `$${d.revenue.toLocaleString()}`));
    }, [data, metric, onPick]);
    return _jsx("svg", { ref: ref, className: "w-full", style: { height: Math.max(80, data.length * 34 + 24) } });
}
